import { BackendUser, useAuthStore } from '~/shared/model/auth';
import { Avatar, AvatarFallback, AvatarImage } from '~/shared/ui/avatar';

import { UserSectionHoverCard } from './UserSectionHoverCard';

function convertUserToShort(user: BackendUser) {
  return {
    avatar: user.avatar,
    fullName: `${user.firstName} ${user.lastName}`,
    initials: `${user.firstName.at(0)?.toLocaleUpperCase()} ${user.lastName.at(0)?.toLocaleUpperCase()}`,
  };
}

export function UserSection() {
  const { isAuthorized, user } = useAuthStore();

  // eslint-disable-next-line no-underscore-dangle
  if (!(isAuthorized && user?._source === 'backend'))
    return (
      <div className="h-[50px] w-[50px] rounded-full bg-accent-foreground" />
    );

  const { avatar, initials, fullName } = convertUserToShort(user);

  return (
    <UserSectionHoverCard>
      <section className="flex cursor-pointer items-center gap-2">
        <Avatar>
          {avatar && <AvatarImage src={avatar} />}
          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
        <span className="hidden whitespace-nowrap xs:inline">{fullName}</span>
      </section>
    </UserSectionHoverCard>
  );
}
